// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a61c0d3b","377":"ffbd988e","475":"659352ab","571":"a2eaf267"}[chunkId] + ".chunk.js";
};